<ng-template #template>
    <div class="modal-body position-relative">
        <div class="text-dark-75 h2 mb-10 ml-5">
            {{ message || ('AreyousureyouwanttoDelete'| localize) }}
            <button type="button" class="close" (click)="cancel()"><i aria-hidden="true"
                    class="ki ki-close"></i></button>
        </div>

        <div class="mb-10 ml-5">
            {{ submessage || ('Youcantundothisaction' | localize) }}
        </div>
        <div class="d-flex justify-content-start">
            <button class="btn btn-outline-danger rounded-0 w-50 mx-6" (click)="cancel()">
                {{ customNoText || ('No' | localize) }}
            </button>
            <button class="btn btn-primary rounded-0 w-50 mx-6" (click)="yes()">
                {{ customYesText || ('Yes' | localize) }}
            </button>
        </div>
        <span class="position-absolute ml-4 ml-md-0 ml-lg-0" style="top: 1rem; left: -2.5rem;">
            <img src="../../../.././../assets/common/images/modalpopup/Group 142322.svg" style="width: 5rem;">
        </span>
    </div>
</ng-template>